<!--
 * @Author: yangliwei 1280426581@qq.com
 * @Date: 2025-01-02 19:07:03
 * @LastEditTime: 2025-01-03 09:43:01
 * @LastEditors: yangliwei 1280426581@qq.com
 * @FilePath: \Mall-Vue\src\App.vue
 * Copyright (c) 2025 by yangliwei, All Rights Reserved.
 * @Description:
-->
<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <!-- 部分路由不应该包含这个Footer -->
    <Footer v-if="excludeRoutes.indexOf($route.name) == -1"></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
export default {
  name: 'App',
  data () {
    return {
      excludeRoutes: ['HomeIndex', 'MyAddress', 'AddAddress', 'MyOrder', 'MyShoppingCart']
    };
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style scoped>
#app{
  background: #F6F6F6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue